import { ComponentType } from "@angular/cdk/portal";
import { inject, Injectable, Injector } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

export interface AppDialog<T> {
    dialogData: T;
}

@Injectable({
    providedIn: "root",
})
export class DialogService {
    private readonly matDialog = inject(MatDialog);
    private injector = inject(Injector);

    open<D, C extends ComponentType<AppDialog<D>>>(component: C, config?: MatDialogConfig<InstanceType<C>["dialogData"]>) {
        return this.matDialog.open<AppDialog<D>, InstanceType<C>["dialogData"], unknown>(component, {
            injector: this.injector,
            ...config,
        });
    }
}
